<template>
	<nav class="navigation">
		<div class="logo">
			<h1 class="logo__text">Studeer Stipt</h1>
		</div>
		<ul class="links">
			<div class="section" v-if="loggedIn">
				<p class="section__header">OVERVIEW</p>
				<router-link
					tag="li"
					:class="{'link--active':isActive('plannings')}"
					class="link"
					to="/plannings">
					<div class="link__icon">
						<i class="link__icon__element fas fa-clipboard-check"></i>
					</div>
					<a>Plannings</a>
				</router-link>
				<router-link
					tag="li"
					:class="{'link--active':isActive('week')}"
					class="link"
					to="/week">
					<div class="link__icon">
						<i class="link__icon__element fas fa-calendar-week"></i>
					</div>
					<a>Week overview</a>
				</router-link>
				<router-link
					style="opacity:0.5"
					tag="li"
					:class="{'link--active':isActive('discussions')}"
					class="link"
					to="/discussions">
					<div class="link__icon">
						<i class="link__icon__element fas fa-comments"></i>
					</div>
					<a>Discussions</a>
				</router-link>
				<router-link
					tag="li"
					:class="{'link--active':isActive('explore')}"
					class="link"
					to="/explore">
					<div class="link__icon">
						<i class="link__icon__element fas fa-search"></i>
					</div>
					<a>Explore</a>
				</router-link>
				<router-link
					style="opacity:0.5"
					tag="li"
					:class="{'link--active':isActive('achievements')}"
					class="link"
					to="/achievements">
					<div class="link__icon">
						<i class="link__icon__element fas fa-medal"></i>
					</div>
					<a>Achievements</a>
				</router-link>
			</div>
			<div
				class="section"
				v-if="plannings">
				<p class="section__header">PLANNINGS</p>
				<router-link
					:key="planning.id"
					v-for="planning in plannings"
					tag="li"
					class="link"
					:to="`/planning/${planning.id}`"
					:class="{'link--active':isActive('planning', planning.id),'link--with-alert':getOpenTasks(planning.Tasks) > 0}">
					<div class="link__icon">
						<i :class="planning.Info.icon" class="link__icon__element"></i>
					</div>
					<a>{{planning.Info.title}}</a>
					<div
						v-if="getOpenTasks(planning.Tasks) > 0"
						class="link__alert">
						<span v-if="getOpenTasks(planning.Tasks) >= 10"><i class="link__alert__icon fas fa-exclamation"></i></span>
						<span v-else-if="getOpenTasks(planning.Tasks) > 0">{{getOpenTasks(planning.Tasks)}}</span>
					</div>
				</router-link>
			</div>
			<div class="section">
				<p class="section__header">SETTINGS</p>
				<router-link
					tag="li"
					:class="{'link--active':isActive('settings')}"
					class="link"
					to="/settings"
					v-if="loggedIn">
					<div class="link__icon">
						<i class="link__icon__element fas fa-cog"></i>
					</div>
					<a>Settings</a>
				</router-link>
				<li class="link"
					@click="logout"
					v-if="loggedIn">
					<div class="link__icon">
						<i class="link__icon__element fas fa-sign-out-alt"></i>
					</div>
					<a href="#">
						Logout
					</a>
				</li>
			</div>
			<div class="section" v-if="loggedIn && userIsSuper">
				<p class="section__header">ADMIN AREA</p>
				<router-link
					tag="li"
					:class="{'link--active':isActive('school-structure')}"
					class="link"
					to="/admin/school-structure"
					v-if="loggedIn && userIsSuper">
					<div class="link__icon">
						<i class="link__icon__element fas fa-school"></i>
					</div>
					<a>School structure</a>
				</router-link>
				<router-link
					tag="li"
					:class="{'link--active':isActive('user-overview')}"
					class="link"
					to="/admin/user-overview"
					v-if="loggedIn && userIsSuper">
					<div class="link__icon">
						<i class="link__icon__element fas fa-user-circle"></i>
					</div>
					<a>User overview</a>
				</router-link>
			</div>
		</ul>
	</nav>
</template>

<script>
import { navigation } from '@/components/mixins/navigation.js'
export default {
	mixins: [navigation]
}
</script>

<style scoped lang="scss">
@import "@/styles/components/_sidebar.scss";
@import "@/styles/components/_navigation.scss";
</style>
